import React from 'react';
import { withFilterFieldBase } from './withFilterFieldBase';
import type { DateRangeFilterFieldProps } from './types';

const DateRangeFilterFieldContent = ({
  filter,
  state,
  inputClassName,
  filtersDisabled,
  updateFilterState,
}: DateRangeFilterFieldProps) => {
  return (
    <div className="grid grid-cols-2 gap-3">
      <input
        className={inputClassName}
        type="date"
        value={state?.min ?? ''}
        disabled={filtersDisabled}
        onChange={event => {
          const value = event.target.value;
          updateFilterState(filter.id, current => ({
            ...current,
            min: value,
            touched: true,
          }));
        }}
      />
      <input
        className={inputClassName}
        type="date"
        value={state?.max ?? ''}
        disabled={filtersDisabled}
        onChange={event => {
          const value = event.target.value;
          updateFilterState(filter.id, current => ({
            ...current,
            max: value,
            touched: true,
          }));
        }}
      />
    </div>
  );
};

export const DateRangeFilterField = withFilterFieldBase(
  DateRangeFilterFieldContent,
  ({
    label,
    filter,
    showGuidedText,
    yearQuickSelects,
    tableDateRange,
    filtersDisabled,
    onYearQuickSelect,
    state,
  }) => ({
    label,
    showGuidedText,
    guidedText: filter.guidedText,
    headerActions:
      yearQuickSelects.length > 0 ? (
        <div className="flex items-center overflow-auto gap-1.5">
          <span className="text-[10px] text-gray-400">Filtrar por:</span>
          {yearQuickSelects.map(({ year, label: yearLabel, range }) => (
            <button
              key={year}
              type="button"
              disabled={filtersDisabled}
              onClick={() => onYearQuickSelect(range, filter.id)}
              className={`rounded px-2 py-0.5 text-[11px] font-medium transition-colors ${
                state?.min === range.minDate && state?.max === range.maxDate
                  ? 'bg-primary text-white'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              } disabled:cursor-not-allowed disabled:opacity-50`}
              title={`Desde ${range.minDate} hasta ${range.maxDate}`}
            >
              {yearLabel}
            </button>
          ))}
          {tableDateRange ? (
            <button
              type="button"
              disabled={filtersDisabled}
              onClick={() => onYearQuickSelect(tableDateRange, filter.id)}
              className="rounded px-2 py-0.5 text-[11px] font-medium text-primary transition-colors hover:bg-primary/10 disabled:cursor-not-allowed disabled:opacity-50"
              title={`Restaurar rango completo: ${tableDateRange.minDate} - ${tableDateRange.maxDate}`}
            >
              Todo
            </button>
          ) : null}
        </div>
      ) : undefined,
  })
);
